import {pluralize} from 'BenchlingUtil';
import {
  ParameterStructuredTableMetadata,
  ParameterStructuredTableRowMetadata,
} from 'notebook/integrations/procedures/ParameterStructuredTableAdapter';
import {ACTION_SUBMIT_PARAMETER} from 'notebook/store/VersioningConstants';
import {
  doPerformCreateParameters,
  PARAMETER_TABLE_MODE_TO_OBJECT_NAME,
} from 'notebook/structured-tables/action-functions//submitParametersActionFunction';
import makeSubmitRowActionFunction, {
  getRowAwareLoadingMessage,
} from 'notebook/structured-tables/action-functions/makeSubmitRowActionFunction';
import {performServerSideTableWriteActionWithAudits} from 'notebook/structured-tables/action-functions/PerformActionFunctions';
import * as ActionFunctionDAO from 'notebook/structured-tables/ActionFunctionDAO';
import {AxisContextMenuActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';

export const SUBMIT_PARAMETER_ROW_ACTION_FUNCTION_CONFIG = {
  allowOutsideOfEntry: false,
  onSelectForSubmit: async (
    params: AxisContextMenuActionFunctionParameters<
      ParameterStructuredTableMetadata,
      ParameterStructuredTableRowMetadata
    >
  ): Promise<void> => {
    const {
      structuredTable,
      structuredTableAdapter,
      computedTable,
      entryOrTemplateId,
      actionFunctionContext,
      selectionRange,
      table,
    } = params;
    const selection = {
      start: selectionRange!.minIndex,
      end: selectionRange!.maxIndex + 1,
    };
    const parameterName = PARAMETER_TABLE_MODE_TO_OBJECT_NAME[structuredTable.metadata.mode];

    await performServerSideTableWriteActionWithAudits<ActionFunctionDAO.ParameterSubmitResponse>({
      entryId: entryOrTemplateId!,
      loadingScreenMessage: getRowAwareLoadingMessage(
        selection,
        `Updating ${pluralize(2, parameterName)} For Rows`,
        `Updating ${parameterName} For Row`
      ),
      autoSaverAction: ACTION_SUBMIT_PARAMETER,
      doPerformAction: ({dataModsHeader, allRowsSubmitted}) =>
        doPerformCreateParameters(
          entryOrTemplateId!,
          structuredTable,
          computedTable,
          actionFunctionContext,
          selection,
          dataModsHeader,
          allRowsSubmitted
        ),
      analyticsActionForPerfTracking: 'submit_parameters_structured_table_rows',
      structuredTables: [structuredTable],
      structuredTableAdapters: [structuredTableAdapter],
      computedTables: [computedTable],
      tables: table ? [table] : [],
      selection,
    });
  },
};

export default makeSubmitRowActionFunction<
  ParameterStructuredTableMetadata,
  ParameterStructuredTableRowMetadata
>(SUBMIT_PARAMETER_ROW_ACTION_FUNCTION_CONFIG);
